<template>
  <div class="forget" style="height:100%">
    <div class="forget_title">
      <h2>找回密码</h2>
      <p>感谢您的使用</p>
    </div>
    <div class="forget_check">
      <!-- 输入手机号，调起手机号键盘 -->
      <van-form @submit="onSubmit">
        <van-field
          :border="false"
          v-model="username"
          type="tel"
          name="username"
          placeholder="请输入您的手机号"
          size="18px"
          @focus="isForgot = true"
        />
        <div class="phone">
          <van-field
            @focus="isForgot = true"
            :border="false"
            v-model="code"
            name="code"
            center
            clearable
            placeholder="请输入您的验证码"
          >
            <template #button>
              <van-button
                size="small"
                native-type="button"
                type="primary"
                @click="sendFindCode(2)"
                :disabled="isSend"
                >{{ sendFindCodeText }}</van-button
              >
            </template>
          </van-field>
        </div>
        <!-- 输入密码 -->
        <van-field
          @focus="isForgot = true"
          class="pass"
          :border="false"
          name="password"
          @blur="checkPassword"
          v-model="password"
          :type="eyeShow ? 'text' : 'password'"
          placeholder="请输入您的密码"
          :right-icon="
            eyeShow
              ? require('../../assets/img/login_password_visible@2x.png')
              : require('../../assets/img/login_password_invisible@2x.png')
          "
          @click-right-icon="eyeShow = !eyeShow"
          clearable
        />
        <!-- 再次输入密码 -->
        <van-field
          @focus="isForgot = true"
          class="repass"
          :border="false"
          v-model="rePassword"
          @blur="checkPassword"
          :right-icon="
            eyeReShow
              ? require('../../assets/img/login_password_visible@2x.png')
              : require('../../assets/img/login_password_invisible@2x.png')
          "
          :type="eyeReShow ? 'text' : 'password'"
          name="rePassword"
          placeholder="请再次输入您的密码"
          @click-right-icon="eyeReShow = !eyeReShow"
        />
        <div class="forget_button">
          <van-button
            round
            type="info"
            native-type="submit"
            :class="isForgot ? 'activeForget' : ''"
            >找回密码</van-button
          >
          <van-button round type="info" class="activeForget" to="/login"
            >登录</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import Title from '../../components/Title'
import { Toast } from 'vant'
import { getRegisterCode, getForgot } from '@/api/home.js'

export default {
  components: {
    Title
  },
  data () {
    return {
      isForgot: false,
      username: '',
      password: '',
      rePassword: '',
      sendFindCodeText: '发送验证码',
      isSend: false,
      code: '',
      eyeShow: false,
      eyeReShow: false,
      timeNum: 60
    }
  },
  methods: {
    // 检测手机号的格式
    isvalidatemobile (phone) {
      const list = []
      let result = true
      let msg = ''
      var isPhone = /^1[3456789]\d{9}$/
      if (phone.length == 11) {
        if (!isPhone.test(phone)) {
          msg = '手机号码格式不正确'
          result = false
        }
      } else {
        msg = '手机号码长度不为11位'
        result = false
      }
      list.push(result)
      list.push(msg)
      return list
    },
    // 发送验证码找回密码
    sendFindCode (val) {
      if (this.username) {
        // 判断手机号是否符合规范
        const validate = this.isvalidatemobile(this.username)
        if (validate[0]) {
          getRegisterCode({ phone: this.username, type: val })
            .then((res) => {
              Toast('发送成功')
              this.setTimeFn()
            })
            .catch((err) => {
              Toast('发送失败请重新发送')
            })
        } else {
          Toast(validate[1])
        }
      } else {
        Toast('请输入手机号')
      }
    },
    // 检测两次密码是否一致,检测密码长度是否符合规范6-12位
    checkPassword () {
      const reg = /^[\w]{6,12}$/
      if (this.password) {
        if (this.password.match(reg)) {
          if (this.password && this.rePassword) {
            if (this.password != this.rePassword) {
              Toast('两次输入的密码不一致')
            }
          }
        } else {
          Toast('请输入6-12位密码')
        }
      }
    },
    // 发送验证码之后的倒计时
    setTimeFn () {
      setTimeout(() => {
        this.isSend = true
        this.timeNum -= 1
        this.sendFindCodeText = '重新获取(' + this.timeNum + ')'
        if (this.timeNum == 0) {
          this.isSend = false
          this.timeNum = 60
          this.sendFindCodeText = '发送验证码'
        } else {
          this.setTimeFn()
        }
      }, 1000)
    },
    // 点击密码找回
    onSubmit (val) {
      if (
        (this.username == '' || this.password == '' || this.rePassword == '',
        this.code == '')
      ) {
        Toast('请正确填写')
      } else {
        getForgot(val)
          .then((res) => {
            if (res.data.code == 0) {
              Toast(res.data.msg)
              setTimeout(() => {
                this.$router.push('/login')
              }, 1000)
            } else {
              Toast(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  },
  beforeDestroy () {
    clearTimeout()
  }
}
</script>

<style lang="scss">
.forget {
  width: 100%;
  background-color: #ffffff;
  background: url("../../assets/img/login_bg@2x.png") no-repeat;
  background-size: 100% 100%;
  // 标题部分
  .forget_title {
    width: 100%;
    height: 1.53rem;
    margin-bottom: 0.42rem;
    padding: 1.01rem 0.15rem 0 0.15rem;

    h2 {
      height: 0.23rem;
      font-size: 0.23rem;

      font-weight: bold;
      color: #93683d;
      line-height: 0.2rem;
      margin-bottom: 0.1rem;
    }
    p {
      font-size: 0.12rem;

      color: #999a9c;
      margin-left: 0.01rem;
    }
  }
  // 验证部分
  .forget_check {
    padding: 0 0.15rem;

    .van-field {
      padding: 0px;
      width: 100%;
      height: 0.44rem;
      background: #ffffff;
      box-shadow: 0rem 0.05rem 0.1rem 0rem rgba(0, 83, 16, 0.04);
      border-radius: 0.08rem;
      margin-bottom: 0.22rem;
      .van-field__body {
        padding: 0 0.14rem;
        .van-field__button {
          .van-button--primary {
            background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
            border-radius: 8px;
            border: none;
            width: 1rem;
            height: 0.29rem;
            color: #93683d;
            font-size: 0.14rem;
            line-height: 0.2rem;
          }
        }
        .van-field__control {
          height: 0.44rem;
          line-height: 0.44rem;
          font-size: 0.14rem;
        }
        input::input-placeholder {
          color: #999a9c;
        }
        input::-webkit-input-placeholder {
          color: #999a9c;
        }
        input:-moz-placeholder {
          color: #999a9c;
        }
        input::-moz-placeholder {
          color: #999a9c;
        }
        input:-ms-input-placeholder {
          color: #999a9c;
        }
      }
    }
  }
  // 底部按钮部分
  .forget_button {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 1.86rem;
    justify-content: center;
    align-items: center;
    .van-button {
      width: 2.72rem;
      height: 0.44rem;
      margin-bottom: 0.22rem;
      border: none;
      font-size: 0.16rem;

      font-weight: bold;
      background: #999a9c;
      box-shadow: 0px 0.05rem 0.1rem 0rem rgba(0, 83, 16, 0.04);
      line-height: 0.2rem;
      &.activeForget {
        color: #93683d !important;
        background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      }
    }
  }
}
</style>
